import { useState, useCallback, useEffect } from 'react'

export const useContent = ({
  mobileBrowser,
  defaultShowState,
  getCollapsibleState = () => {},
  id,
  openCollapseTargetId,
}) => {
  const initialShowContent = id === openCollapseTargetId ? true :
    defaultShowState !== undefined ? defaultShowState : !mobileBrowser

  const [showContent, setShowContent] = useState(initialShowContent)

  useEffect(() => {
    setShowContent(initialShowContent)
  }, [openCollapseTargetId])

  const setContent = () => {
    setShowContent(!showContent)
    getCollapsibleState(!showContent)
  }

  return { showContent, setContent }
}

export const useGoogleAnalytics = ({
  lookups,
  gaActionTitle,
  title,
  showContent,
  googleAnalyticsEvent,
}) =>
  useCallback(() => {
    if(lookups && lookups.component) {
      const category = lookups.component
      const actionBase = '[Collapsible Click]'
      const actionBase2 = `${actionBase}[${gaActionTitle || title}]`
      const actions = [
        actionBase,
        actionBase2,
        actionBase2 + `[${showContent ? 'Close' : 'Open'}]`,
      ]
      actions.forEach(action =>
        (googleAnalyticsEvent ? googleAnalyticsEvent({
          category,
          action,
        }) : null),
      )
    }
  }, [lookups, gaActionTitle, title, showContent, googleAnalyticsEvent])
